import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { OverlaySpinnerState } from '../models/overlay-spinner.model';

@Injectable({
  providedIn: 'root'
})
export class OverlaySpinnerService {
  private initialState: OverlaySpinnerState = {
    show: false,
    message: 'Загрузка... Пожалуйста, подождите',
    color: 'primary'
  };

  private spinnerSubject = new BehaviorSubject<OverlaySpinnerState>(this.initialState);

  getState(): Observable<OverlaySpinnerState> {
    return this.spinnerSubject.asObservable();
  }

  show(options?: Partial<OverlaySpinnerState>): void {
    this.spinnerSubject.next({
      ...this.initialState,
      ...options,
      show: true
    });
  }

  hide(): void {
    this.spinnerSubject.next({
      ...this.spinnerSubject.value,
      show: false
    });
  }
}